module.exports = _.isFinite;